import type { PagesConfig } from '#types/config/pages'

export default {
  supportedLocales: ['en-gb', 'de-de']
} satisfies PagesConfig['loyaltyProgramme']
